import React from 'react';

import {
  IMatchCommentEventData,
  IMatchCommentEventMap,
  MatchCommentEvent,
  MatchEventMapData,
} from '../typings/match-comments';
import {
  IconCorners,
  IconFoulsCommitted,
  IconOffside,
  IconRedCardWithoutHand,
  IconRedYellowCard,
  IconScored,
  IconSubstitutionColored,
  IconVar,
  IconWin,
  IconWoodwork,
  IconYellowCardWithoutHand,
} from '../components';

export const greenWhistleData: MatchEventMapData = {
  icon: (props) => <IconFoulsCommitted {...props} />,
  color: 'match-comments-success',
  iconColor: 'blue',
};

export const blueFlaggedData: MatchEventMapData = {
  icon: (props) => <IconOffside {...props} />,
  color: 'blue',
  iconColor: 'blue',
};

export const redScoredData: MatchEventMapData = {
  icon: (props) => <IconScored {...props} />,
  color: 'match-comments-orange',
  iconColor: 'match-comments-orange',
};

export const blueScoredData: MatchEventMapData = {
  icon: (props) => <IconScored {...props} />,
  color: 'blue',
};

export const redCrossData: MatchEventMapData = {
  icon: (props) => <IconWin {...props} />,
  color: 'match-comments-danger',
  iconColor: 'match-comments-danger',
};

export const bluePostData: MatchEventMapData = {
  icon: (props) => <IconWoodwork {...props} />,
  color: 'blue',
};

export const redCardData: MatchEventMapData = {
  icon: (props) => <IconRedCardWithoutHand {...props} />,
  color: 'match-comments-danger',
};

export const yellowCardData: MatchEventMapData = {
  icon: (props) => <IconYellowCardWithoutHand {...props} />,
  color: 'match-comments-warning',
};

export const expulsionData: MatchEventMapData = {
  icon: (props) => <IconRedYellowCard {...props} />,
  color: 'match-comments-danger',
};

export const substitionData: MatchEventMapData = {
  icon: (props) => <IconSubstitutionColored {...props} />,
  color: 'blue',
};

export const varDeniedData: MatchEventMapData = {
  icon: (props) => <IconVar {...props} />, // icon to be added
  color: 'match-comments-danger',
};

export const varCheckData: MatchEventMapData = {
  icon: (props) => <IconVar {...props} />, // icon to be added
  color: 'match-comments-danger',
};

export const cornerData: MatchEventMapData = {
  icon: (props) => <IconCorners {...props} />,
  color: 'blue',
  iconColor: 'blue',
};
export const matchEventsMap: IMatchCommentEventMap = {
  'end 1': greenWhistleData,
  'end 2': greenWhistleData,
  'end 3': greenWhistleData,
  'end 4': greenWhistleData,
  'end 5': greenWhistleData,
  'end 14': greenWhistleData,
  offside: blueFlaggedData,
  corner: cornerData,
  substitution: substitionData,
  goal: blueScoredData,
  'second yellow card': expulsionData,
  'secondyellow card': expulsionData,
  'yellow card': yellowCardData,
  'penalty goal': blueScoredData,
  'contentious referee decisions': varCheckData,
  start: greenWhistleData,
  post: bluePostData,
  'red card': redCardData,
  'own goal': redScoredData,
  'player retired': redCrossData,
  'VAR cancelled goal': varDeniedData,
};
export const getMatchEventData = (type: MatchCommentEvent): IMatchCommentEventData | null =>
  matchEventsMap[type as keyof IMatchCommentEventMap]
    ? { ...matchEventsMap[type as keyof IMatchCommentEventMap], type }
    : null;
